<template>
  <div id="login">
    <section class="bannerprincipal">
      <div class="">
        <div class="row">
          <div class="col-12 col-md-12 offset-md-0 h-100 pb-5">
            <div class="">
              <div
                class="d-flex justify-content-center align-items-center fanta amarillo fXG"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="px-lg-0 mb-5">
      <div class="pt-lg-5">
        <div class="row pasos text-center">
          <div class="col-6" data-aos="fade-right" :data-aos-delay="basedelay + 200">
            <img
              src="../assets/imgs/verano23/mnms-verano.png"
              alt="Verano Cinépolis"
              class="img-fluid"
            />
          </div>

          <div class="col-6 pr-4 pr-lg-5" data-aos="fade-left" :data-aos-delay="basedelay + 200">
            <img
              src="../assets/imgs/verano23/combo-home.png"
              alt="Verano Cinépolis"
              class="img-fluid w-100 palomitashome"
            />
          </div>

          
        </div>
      </div>
    </section>

    <section id="registro" class="px-5 px-lg-0" data-aos="fade-up" :data-aos-delay="basedelay + 400">
      <div class="pt-lg-5">
        <div class="row">
          <div class="col-lg-6 px-0 px-lg-5">
            <div class="row pb-4">
              <div class="col-lg-12 offset-lg-0">
                <div class="fXXG amarillo fanta text-center">¡Regístrate!</div>
              </div>
            </div>

            <div id="loginregistro" class="row pb-5">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 z100">
                    <form @submit="signup($event)" class="py-5 r15">
                      <div class="col-12">
                        <div class="row pb-4">
                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">Nombre</div>
                            <input
                              v-model.trim="signupForm.nombre"
                              type="text"
                              placeholder="Nombre"
                              id="nombre"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">Apellido Paterno</div>
                            <input
                              v-model.trim="signupForm.apellido"
                              type="text"
                              placeholder="Apellido Paterno"
                              id="apellido"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">Apellido Materno</div>
                            <input
                              v-model.trim="signupForm.apellido2"
                              type="text"
                              placeholder="Apellido Materno"
                              id="apellido"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">
                              Correo electrónico
                            </div>
                            <input
                              v-model.trim="signupForm.email"
                              type="email"
                              placeholder="Correo electrónico"
                              id="nombre"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">Celular</div>
                            <input
                              v-model.trim="signupForm.celular"
                              type="text"
                              placeholder="Celular (10 dígitos)"
                              id="celular"
                              maxlength="10"
                              required
                            />
                          </div>
                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">Contraseña</div>
                            <input
                              v-model.trim="signupForm.password"
                              type="password"
                              placeholder="Contraseña"
                              id="password2"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">
                              Fecha de nacimiento
                            </div>
                            <input
                              v-model.trim="signupForm.fecha_nacimiento"
                              type="date"
                              placeholder="Fecha de nacimiento"
                              id="fecha_nacimiento"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">Estado</div>
                            <!-- <div class="small blanco fanta">Ingresa tu membresía para obtener más puntos por ticket registrado</div> -->
                            <select v-model.trim="signupForm.estado" required >

                              <option value="">Selecciona un estado</option>
                              <option value="Aguascalientes">Aguascalientes</option>
                              <option value="Baja California">Baja California</option>
                              <option value="Baja California Sur">Baja California Sur</option>
                              <option value="Campeche">Campeche</option>
                              <option value="Chiapas">Chiapas</option>
                              <option value="Chihuahua">Chihuahua</option>
                              <option value="CDMX">Ciudad de México</option>
                              <option value="Coahuila">Coahuila</option>
                              <option value="Colima">Colima</option>
                              <option value="Durango">Durango</option>
                              <option value="Estado de México">Estado de México</option>
                              <option value="Guanajuato">Guanajuato</option>
                              <option value="Guerrero">Guerrero</option>
                              <option value="Hidalgo">Hidalgo</option>
                              <option value="Jalisco">Jalisco</option>
                              <option value="Michoacán">Michoacán</option>
                              <option value="Morelos">Morelos</option>
                              <option value="Nayarit">Nayarit</option>
                              <option value="Nuevo León">Nuevo León</option>
                              <option value="Oaxaca">Oaxaca</option>
                              <option value="Puebla">Puebla</option>
                              <option value="Querétaro">Querétaro</option>
                              <option value="Quintana Roo">Quintana Roo</option>
                              <option value="San Luis Potosí">San Luis Potosí</option>
                              <option value="Sinaloa">Sinaloa</option>
                              <option value="Sonora">Sonora</option>
                              <option value="Tabasco">Tabasco</option>
                              <option value="Tamaulipas">Tamaulipas</option>
                              <option value="Tlaxcala">Tlaxcala</option>
                              <option value="Veracruz">Veracruz</option>
                              <option value="Yucatán">Yucatán</option>
                              <option value="Zacatecas">Zacatecas</option>

                            </select>
                          </div>


                          <div class="col-lg-6 pb-3">
                            <div class="fG blanco fanta">Club Cinépolis (opcional)</div>
                            <!-- <div class="small blanco fanta">Ingresa tu membresía para obtener más puntos por ticket registrado</div> -->
                            <input
                              v-model.trim="signupForm.club_cinepolis"
                              type="text"
                              placeholder="Club Cinépolis (opcional)"
                              id=""
                            />
                          </div>

                          <div class="col-12 pb-0 text-center blanco">
                            <label>
                              <input
                                type="checkbox"
                                v-model="signupForm.terminos"
                                required
                              />
                              He leído y acepto los <router-link class="blanco underlined" target="_blank" to="#">términos y condiciones</router-link> y el
                              
                              <a
                                href="https://www.pautacreativa.com.mx/?aviso=1"
                                class="blanco2 underlined"
                                target="_blank"
                                rel="noopener noreferrer"
                                >aviso de privacidad</a
                              >.
                            </label>
                          </div>
                        </div>
                        <div class="row pb-0">
                          <div class="col-12 text-center">
                            <button
                              type="submit"
                              class="pointer d-flex align-items-center justify-content-center btnaction2 fXG ml-auto mr-auto fanta"
                            >
                              Registrar
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="inicia-sesion" class="col-lg-6 px-0 px-lg-5">
            <div class="row">
              <div class="col-12">
                    <form @submit="login($event)" class="pb-5 r15">
                      <div class="col-12">
                        <p class="fanta fXXG verde text-center pb-2">
                          INICIA SESIÓN
                        </p>
                      </div>

                      <div class="col-12">
                        <div class="d-flex flex-column py-5">
                          <div class="w-100 px-0">
                            <span class="fanta blanco fG">
                              Correo electrónico
                            </span>
                            <input
                              v-model.trim="loginForm.email"
                              type="email"
                              placeholder="Correo electrónico"
                              id="email1"
                              class="text-left"
                              required
                            />
                          </div>
                          <div class="w-100 px-0">
                            <span class="fanta blanco fG"> Contraseña </span>
                            <input
                              v-model.trim="loginForm.password"
                              type="password"
                              placeholder="Contraseña"
                              id="password1"
                              class="text-left"
                              required
                            />
                          </div>
                          <div
                            class="px-2 text-center d-flex align-items-center"
                          >
                            <button
                              type="submit"
                              class="pointer d-flex align-items-center justify-content-center btnaction fXG ml-auto mr-auto fanta"
                            >
                              Entrar
                            </button>
                          </div>
                        </div>
                        <div class="extras text-center amarillo fanta">
                          <a
                            @click="togglePasswordReset()"
                            class="pointer blanco"
                            >Olvidé mi constraseña</a
                          >
                        </div>
                      </div>
                    </form>
                  </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";

import mobile from "is-mobile";

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        apellido2: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        club_cinepolis: "",
        estado: ""
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      basedelay: 200
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      //disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);

    //console.log({mobile: mobile()});
    if(mobile()){
      this.basedelay = 400;
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      this.registro();
    },
    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      await this.enviaCorreo(
        this.signupForm.nombre,
        this.signupForm.apellido,
        this.signupForm.apellido2,
        this.signupForm.email,
        this.signupForm.celular,
        this.signupForm.fecha_nacimiento,
        this.signupForm.club_cinepolis
      );

      // await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, apellido2, email, celular, fecha_nacimiento, club_cinepolis) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        apellido2: apellido2,
        email: email,
        celular: celular,
        fecha_nacimiento: fecha_nacimiento,
        club_cinepolis: club_cinepolis
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {


              let entradas = {
                entrada1:{
                  barcode: res.barcode1,
                  nombre: res.nombre1,
                  id_beneficio: res.id_beneficio1
                },
                entrada2:{
                  barcode: res.barcode2,
                  nombre: res.nombre2,
                  id_beneficio: res.id_beneficio2
                }
              };

              thes.signupForm.entradas = entradas;



              await this.$store.dispatch("signup", thes.signupForm);

              // thes.$gtag.event("conversion", {
              //   send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              // });

              //window.fbq("track", "CompleteRegistration");
              

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        apellido2: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminos: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
